module.exports = __webpack_public_path__ + "img/nature-doc.47c21e12.webp";